export enum MediatorEventType {
  EMPTY_MESSAGE = "MYBETS_EMPTY_MESSAGE",
  MODAL_CLOSE_FDR = "MYBETS_MODAL_CLOSE_FDR",
  CONFIRM_DELETE_BET_FDR = "MYBETS_CONFIRM_DELETE_BET_FDR",
  TAB_SELECT_FDR = "MYBETS_TAB_SELECT_FDR",
  OPEN_FROM_FOOTER_FDR = "MYBETS_OPEN_FROM_FOOTER_FDR",
  OPEN_LIVE_VIDEO = "MYBETS_OPEN_LIVE_VIDEO",
  RACE_ACTIVE_BETS_MODAL_CLOSE = "RACE_ACTIVE_BETS_MODAL_CLOSE",
  RACE_ACTIVE_BETS_MODAL_OPEN = "RACE_ACTIVE_BETS_MODAL_OPEN",
  RACE_ACTIVE_BETS_MODAL_RETURN = "RACE_ACTIVE_BETS_MODAL_RETURN"
}
export type EmptyMessageEventData = {
  type: MediatorEventType.EMPTY_MESSAGE;
  payload: {
    buttonText: string;
    module: string;
    destinationUrl: string;
  };
};

export type TabSelectEventData = {
  type: MediatorEventType.TAB_SELECT_FDR;
  payload: {
    selectedTab: string;
    activeTab: string;
  };
};

export type LiveVideoEventData = {
  type: MediatorEventType.OPEN_LIVE_VIDEO;
  payload: {
    tag: string;
    raceUrl: string;
  };
};

export type RaceActiveBetsEventData = {
  type: MediatorEventType.RACE_ACTIVE_BETS_MODAL_RETURN;
  payload: {
    trackName: string;
    raceNumber: string;
    mtp: number;
    destinationUrl: string;
  };
};
